require('../dataTransformers/clipTransformer');

angular.module('app.shared.clipSearchService', [])
  .factory(
    'app.shared.clipSearchService', [
      '$http',
      '$httpParamSerializerJQLike',
      'app.shared.dataTransformers.clipTransformer',
      ($http,
       $httpParamSerializerJQLike,
       clipTransformer) => {
        "use strict";

        return {
          retrieve: (params) => {
            params = $httpParamSerializerJQLike(params);
            return $http.get(window.location.api('/clips_my_clips?' + params))
              .then(
                response => {
                  let data = response.data;

                  if (Array.isArray(data.clips)) {
                    for (let i = 0; i < data.clips.length; i++) {
                      let clip = data.clips[i];
                      clip = clipTransformer.transformToUi(clip);
                      data.clips[i] = clip;
                    }
                    response.data.clips = data.clips;
                  }

                  return response;
                }
              );
          },
          retrieveFilters: () => {
            return $http.get(window.location.api('/clips_filters/user'));
          },

          retrieveSeasons: (params) => {
            params = $httpParamSerializerJQLike(params);
            return $http.get(window.location.api('/clips/my_seasons?' + params));
          }
        };
      }
    ]
  );


// WEBPACK FOOTER //
// ./app.v2/components/shared/clipSearch/clipSearchService.js